import LoginForm from "../components/LoginForm/LoginForm";
import "../styles.css/login-page.css";

export default function Login() {
  return (
    <div className="login-main">
      <LoginForm />
    </div>
  );
}
